/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PatchSdkKeyByKeyPathParams = NonNullable<operations['patchSdkKeyByKey']['parameters']['path']>;

export type PatchSdkKeyByKeyQueryParams = NonNullable<operations['patchSdkKeyByKey']['parameters']['query']>;

export type PatchSdkKeyByKeyRequestBody = OperationRequestBodyContent<operations['patchSdkKeyByKey']>;

export interface Input extends PatchSdkKeyByKeyPathParams {
  apiVersion?: string;
  query?: PatchSdkKeyByKeyQueryParams;
  body: PatchSdkKeyByKeyRequestBody;
  header: NonNullable<operations['patchSdkKeyByKey']['parameters']['header']>;
}

export async function patchSdkKeyByKey(
  { apiVersion, body, query, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/api/v2/projects/{projectKey}/environments/{environmentKey}/sdk-keys/{sdkKeyKey}', {
    params: { path, query, header },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
